import {Box, Button, Typography} from '@mui/material'
import { useNavigate } from 'react-router-dom'

export default function QuestionsButton({question}) {
    const navigate = useNavigate()

    const slugify = (str) => {
        return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
    }

    const handleRowClick = (idQuestion) => {
        navigate(`/ideNew/${idQuestion}`)
    }

    return (
        <Box>
            <Button 
                data-cy={`roadmap-questions-button-${slugify(question.title)}`}
                variant='contained'
                onClick={() => handleRowClick(question._id.toString())}
                sx={{
                    width: '100%',
                    height: '100%',
                    textTransform: 'none',
                    justifyContent: 'space-between',
                    color: '#CEC9BE',
                    background: '#110A0E',
                    borderRadius: '12px',
                    "&:hover": {
                        backgroundColor: '#404040',
                    }
                }}
            >
                <Typography variant='h7'>
                    {question.title}
                </Typography>
                <Typography variant='h7' sx={{
                    color: question.difficulty === "Easy" ? '#87D096' : question.difficulty === "Medium" ? "#F8A828" : "#E43B37"
                }}>
                    {question.difficulty}
                </Typography>
            </Button>
        </Box>
    )

}